import React from 'react';
import { Section } from '@radix-ui/themes';

import PageTitle from 'components/layout/PageTitle';
import BoardWrite from 'components/board/BoardWrite';

// 게시판 관리 > 부처소식 관리 > 등록
export default function DepartmentWrite() {
  const boardType = 'department';

  return (
    <Section>
      <PageTitle title="부처소식 등록" />
      <BoardWrite boardType={boardType} />
    </Section>
  );
}
